import { ArrowRight, Chrome } from 'lucide-react'
import { Link } from 'react-router'
import { CHROME_EXTENSION_URL } from '#app/constants/links.ts'
import { useExtensionDetection } from '#app/hooks/useExtensionDetection.ts'
import { SignedIn } from './auth/SignedIn'
import { SignedOut } from './auth/SignedOut'
import { SignUpButton } from './auth/SignUpButton'
import { Button } from './ui/button'

export function MainCTAButtons({
	variant = 'default',
	size = 'xl',
	className = '',
}: {
	variant?: 'default' | 'secondary'
	size?: 'sm' | 'default' | 'lg' | 'xl'
	className?: string
	showBadge?: boolean
}) {
	const { isExtensionInstalled } = useExtensionDetection()

	// If extension is not installed, show install button (default state)
	if (!isExtensionInstalled) {
		return (
			<div className="flex flex-col gap-4 sm:flex-row">
				<div className="relative">
					<Button
						size={size}
						className={`gap-2 ${className}`}
						variant={variant}
						asChild
					>
						<Link to={CHROME_EXTENSION_URL}>
							<Chrome className="h-4 w-4" />
							Add to Chrome
						</Link>
					</Button>
				</div>
			</div>
		)
	}

	// If extension is installed, show different CTAs based on auth state
	return (
		<div className="flex flex-col gap-4 sm:flex-row">
			<SignedOut>
				<SignUpButton size={size} className={`gap-2 ${className}`}>
					Sign Up
				</SignUpButton>
			</SignedOut>
			<SignedIn>
				<Button
					size={size}
					className={`gap-2 ${className}`}
					variant={variant}
					asChild
				>
					<Link to="/account">
						<ArrowRight className="h-4 w-4" />
						Go to Account
					</Link>
				</Button>
			</SignedIn>
		</div>
	)
}
